// extracted by mini-css-extract-plugin
var _1 = "Authors_dot__d2592";
var _2 = "Authors_resolved__92a6e";
var _3 = "Authors_root__68fe3";
export { _1 as "dot", _2 as "resolved", _3 as "root" }
